module.exports = __webpack_public_path__ + "img/mv.703a3a7a.jpg";